import {HTTP} from '../http-common';
import discovery from '../discovery';

export default {
    // Constantes
    //TIPO:1,
    // Funciones comunes
    checkVersionHeader: function (response) {
        var version = response.headers['x-service-version'];
        if (window.$vue.$store.state.flexiapp.serviceVersion != version) {
           // window.$vue.$store.commit('flexiapp/setServiceVersion',version);
            console.log("Service version:"+version);
        }
    },
    getCommonHeaders()
    {
        var headers = {};

        headers = {
            'authorization': 'Bearer ' + window.localStorage.getItem("vue-token")
        };

        if (/MSIE|Trident/.test(window.navigator.userAgent))
        {
            headers['Pragma'] = 'no-cache';
            headers['Cache-Control'] = 'no-cache, no-store';
        }

        return { headers: headers };
    },
    getServiceEndpoint(service)
    {
        if (service.indexOf('http')==0) return service;

        return discovery.flexiapp_service_url+service;
    },
    genericGet(service,cbok, cberr)
    {
        HTTP
            .get(this.getServiceEndpoint(service),
            this.getCommonHeaders())
            .then((response) => {
                this.checkVersionHeader(response);
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericPut (service,data,cbok, cberr)
    {
        HTTP
            .put(this.getServiceEndpoint(service),
            data,this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericPost(service,data,cbok, cberr)
    {
        HTTP
            .post(this.getServiceEndpoint(service),
            data,this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },
    genericDelete(service,cbok, cberr)
    {
        HTTP
            .delete(this.getServiceEndpoint(service),
            this.getCommonHeaders())
            .then((response) => {
                cbok(response.data);
            }).catch(function (error) {
                cberr(error);
            });
    },

    /////////////////////////////////////////////////////////////////
    //COMMON

    getSessionToken (data,cbok, cberr)
    {
        data.AppId = discovery.appId;
        this.genericPost(discovery.flexiapp_auth_url,data,cbok, cberr);
    },

    getUserInfo (cbok, cberr)
    {
        this.genericGet('api/Employee/me',cbok, cberr);
    },

    getWorkOrders (employeeId, offset, limit, version, search, sortBy, sortDesc,cbok, cberr)
    {
        //this.genericGet('api/Depots/'+depotId+'/Workorders?search='+search+'&sortBy='+sortBy+'&sortDesc='+sortDesc+'&Offset='+offset+'&Limit='+limit, cbok, cberr); 
        this.genericGet('api/Employee/'+employeeId+'?Offset='+offset+'&Limit='+limit+'&version='+version, cbok, cberr); 
    },
    getWorkOrder (id,cbok, cberr)
    {
        this.genericGet('api/Workorders/'+id, cbok, cberr);
    },
    getAsseembleGuideSteps (workorderId,lineId, cbok, cberr)
    {
        this.genericGet('api/Workorders/'+workorderId+'/Lines/'+lineId+'/Steps', cbok, cberr);
    },
    putWorkOrderLine(workorderId,lineId,data,cbok, cberr){
        this.genericPut('api/Workorders/'+workorderId+'/Lines/'+lineId,data,cbok, cberr);
    },
    getUserImages (workorderId,lineId, cbok, cberr)
    {
        this.genericGet('api/Workorders/'+workorderId+'/Lines/'+lineId+'/Steps/Images', cbok, cberr);
    },
    postPicture(workorderId,lineId,data,cbok, cberr){
        this.genericPost('api/Workorders/'+workorderId+'/Lines/'+lineId+'/Steps/Images',data,cbok, cberr);
    },
    putWorkOrder(workorderId,data,cbok, cberr)
    {
        this.genericPut('api/Workorders/'+workorderId,data,cbok, cberr);
    },
    getImage(token, cbok, cberr)
    {
        this.genericGet('api/Images/'+token,cbok, cberr);
    },
    deleteImageByToken(workorderId,lineId,token, cbok, cberr)
    {
        this.genericDelete('api/Workorders/'+workorderId+'/Lines/'+lineId+'/Steps/Images/'+token,cbok, cberr);
    },
}
